module.exports = __webpack_public_path__ + "6026842a.png";